import { buildIndex } from './loader';
import type { ContentIndex, Shell } from './types';

/**
 * The build time import. Vite reads every page in content/ at build time and
 * inlines it, so the apps ship their guidebook inside the bundle and a page
 * works with the network off from the first visit, not the second.
 *
 * The glob pattern has to be a literal for Vite to statically analyse it,
 * which is why this file exists separately from the pure loader.
 *
 * The negative patterns are not a tidy up, they are defect D11. `eager` inlines
 * the file contents into the bundle at build time, so filtering after the glob
 * would remove a page from the index and leave its text in the JavaScript for
 * anybody to read. The working notes (PLACEHOLDERS.md, which says things like
 * "CLAUDE.md may still say ...") and the conventions README are not pages and
 * must never leave this repository. They have to be excluded here, in the
 * pattern, or not at all.
 */
const FILES = import.meta.glob(
  [
    '../../../content/**/*.md',
    '!../../../content/**/PLACEHOLDERS.md',
    '!../../../content/README.md',
  ],
  {
    eager: true,
    query: '?raw',
    import: 'default',
  },
) as Record<string, string>;

let cached: ContentIndex | null = null;

export function loadContent(): ContentIndex {
  if (!cached) cached = buildIndex(FILES);
  return cached;
}

/** The guest shell never even sees the ops pages, and the other way round. */
export function loadShell(shell: Shell): ContentIndex {
  const files = Object.fromEntries(
    Object.entries(FILES).filter(([path]) => path.includes(`/content/${shell}/`)),
  );
  return buildIndex(files);
}
